import { getAPIUrl } from "../../shared/helper";
import Api from "../../network/axiosClients";
import { AxiosResponse } from "axios";

// allowing cache for get methods in specific APIs
const cache: { methods: ["get"] } = {
  methods: ["get"]
};

export const getAll = async (endPoint: string): Promise<AxiosResponse> => {
  return Api.get(endPoint);
};

export const getLocationByName = async (location: string): Promise<AxiosResponse> => {
  return Api.get(getAPIUrl("locations", { searchText: location, take: 100, page: 1 }), { cache });
};
export const getState = async (location: string): Promise<AxiosResponse> => {
  return Api.get(getAPIUrl("state", { searchText: location, take: 100, page: 1, status: true }), { cache });
};

export const getAllActivePartner = async (): Promise<AxiosResponse> => {
  return Api.get(getAPIUrl("partner?status=true"), { cache });
};

export const getLineOfBusiness = async (): Promise<AxiosResponse> => {
  return Api.get("line-of-businesses", { cache });
};
export const getUserType = async (): Promise<AxiosResponse> => {
  return Api.get("users/user-type/list-of-values", { cache });
};

export const getListOfValue = async (type: string, avoidCache?: boolean): Promise<AxiosResponse> => {
  return Api.get(getAPIUrl("list-of-values", { type, take: 100, page: 1 }), avoidCache ? {} : { cache });
};

export const getNumericTypeValues = async (): Promise<AxiosResponse> => {
  return Api.get(getAPIUrl("numeric-type-values"), { cache });
};

export const getTakafulProviderListOfValues = async (searchText?: string, status?: boolean): Promise<AxiosResponse> => {
  return Api.get(getAPIUrl("takaful-providers/list-of-values", { searchText, status, take: 100, page: 1 }), { cache });
};
export const getAutoPlanType = async (searchText?: string, status?: boolean): Promise<AxiosResponse> => {
  return Api.get(getAPIUrl("plan-type", { searchText, status, take: 100, page: 1, lineOfBusinessId: 1 }), { cache });
};

export const getAllUserPermission = async (): Promise<AxiosResponse> => {
  return Api.get("users/permissions", { cache });
};

export const getAllActiveUser = async (): Promise<AxiosResponse> => {
  return Api.get("feature-flag/active", { cache });
};
